export default __webpack_public_path__ + "static/media/view-more.e403055c.jpg";